import { DataGrid, DataGridProps, GridValidRowModel } from "@mui/x-data-grid";

export type ItecDataGridProps<TEntity extends GridValidRowModel> = Omit<
  DataGridProps<TEntity>,
  "paginationMode" | "filterMode"
>;

export function ItecDataGrid<TEntity extends GridValidRowModel>(
  props: ItecDataGridProps<TEntity>
) {
  const { slots, ...rest } = props;

  return (
    <DataGrid
      paginationMode="server"
      filterMode="server"
      slots={{
        columnMenuIcon: () => <></>,
        ...slots,
      }}
      autoHeight={true}
      {...rest}
    />
  );
}
